import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const ROLE = {
    ADMIN: 'admin',
    MEMBER: 'member',
};

class ChangeRole extends React.Component {
    constructor(props) {
        super(props);
        const { users } = this.props;
        // If we are changing the role for only one user set his current role
        // as checked, otherwise leave it undefined
        let checkedValue;
        if (users.length === 1) {
            checkedValue = users[0].isAdmin ? ROLE.ADMIN : ROLE.MEMBER;
        }

        this.state = {
            checkedValue,
        };
    }

    onChange = e => {
        this.setState({ checkedValue: e.target.value });
    };

    onSubmit = () => {
        const { checkedValue } = this.state;
        const { users, onSubmit } = this.props;

        const isAdmin = checkedValue === ROLE.ADMIN;
        const membersIds = users.map(user => user.id);
        onSubmit({ membersIds, isAdmin });
    };

    render() {
        const { isOpen, closeDialog } = this.props;
        return (
            <Dialog open={isOpen} onClose={closeDialog}>
                <DialogTitle>Change role</DialogTitle>
                <DialogContent>
                    <RadioGroup
                        name="role"
                        value={this.state.checkedValue}
                        onChange={this.onChange}
                    >
                        <FormControlLabel
                            value={ROLE.ADMIN}
                            control={<Radio color="primary" />}
                            label="Admin"
                        />
                        <FormControlLabel
                            value={ROLE.MEMBER}
                            control={<Radio color="primary" />}
                            label="Member"
                        />
                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>CANCEL</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onSubmit}
                        disabled={!this.state.checkedValue}
                    >
                        CHANGE ROLE
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

ChangeRole.propTypes = {
    users: PropTypes.array,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
};

ChangeRole.defaultProps = {
    users: [],
};

export default ChangeRole;



// WEBPACK FOOTER //
// ./src/components/ChangeUserRole.js